if (!customElements.get("m-wholesale-order")) {
  class MWholesaleOrder extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector("[data-wholesale-form]");
      if (!this.form || this.form.dataset.bound === "true") return;
      this.form.dataset.bound = "true";
      this.totalEl = this.querySelector("[data-wholesale-total]");
      this.messageEl = this.querySelector("[data-wholesale-message]");
      this.submitButton = this.querySelector("[data-wholesale-submit]");
      this.submitLabel = this.querySelector("[data-wholesale-submit-label]");
      this.submitText = this.submitLabel ? this.submitLabel.textContent : "Add to cart";
      this.onInput = this.onInput.bind(this);
      this.onSubmit = this.onSubmit.bind(this);
      this.form.addEventListener("input", this.onInput);
      this.form.addEventListener("submit", this.onSubmit);
      this.syncTotals();
    }

    money(cents) {
      const format = (window.MinimogSettings && window.MinimogSettings.money_format) || "${{amount}}";
      if (typeof formatMoney === "function") return formatMoney(cents, format);
      return "$" + (Number(cents) / 100).toFixed(2);
    }

    onInput() {
      this.syncTotals();
      this.setMessage("");
    }

    syncTotals() {
      let total = 0;
      this.querySelectorAll("[data-wholesale-row]").forEach((row) => {
        const unit = Number(row.dataset.unitCents || 0);
        const input = row.querySelector("[data-wholesale-qty]");
        const qty = input ? Math.max(0, parseInt(input.value, 10) || 0) : 0;
        const line = unit * qty;
        total += line;
        const lineEl = row.querySelector("[data-wholesale-line]");
        if (lineEl) lineEl.textContent = this.money(line);
      });
      if (this.totalEl) this.totalEl.textContent = this.money(total);
    }

    setMessage(text, isError) {
      if (!this.messageEl) return;
      this.messageEl.hidden = !text;
      this.messageEl.textContent = text || "";
      this.messageEl.classList.toggle("is-error", Boolean(isError));
    }

    onSubmit(event) {
      event.preventDefault();
      if (!this.submitButton || this.submitButton.disabled) return;

      const items = [];
      this.querySelectorAll("[data-wholesale-row]").forEach((row) => {
        if (row.dataset.available === "false") return;
        const input = row.querySelector("[data-wholesale-qty]");
        const qty = input ? Math.max(0, parseInt(input.value, 10) || 0) : 0;
        if (qty < 1) return;
        items.push({ id: Number(row.dataset.variantId), quantity: qty });
      });

      if (!items.length) {
        this.setMessage("Enter a quantity for at least one size.", true);
        return;
      }

      const routes = (window.MinimogSettings && window.MinimogSettings.routes) || {};
      const addUrl = (routes.cart_add_url || "/cart/add") + ".js";
      const cartUrl = routes.cart || "/cart";

      this.submitButton.disabled = true;
      if (this.submitLabel) this.submitLabel.textContent = "Adding…";
      this.setMessage("");

      fetch(addUrl, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ items: items }),
      })
        .then((response) => response.json().then((data) => ({ ok: response.ok, data: data })))
        .then(({ ok, data }) => {
          if (!ok || (data && data.status)) {
            const message = (data && (data.description || data.message)) || "Could not add this order to the cart.";
            this.setMessage(message, true);
            this.submitButton.disabled = false;
            if (this.submitLabel) this.submitLabel.textContent = this.submitText;
            return;
          }
          window.location.assign(cartUrl);
        })
        .catch(() => {
          this.setMessage("Could not add this order to the cart.", true);
          this.submitButton.disabled = false;
          if (this.submitLabel) this.submitLabel.textContent = this.submitText;
        });
    }
  }

  customElements.define("m-wholesale-order", MWholesaleOrder);
}
